import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { drawerWidth, navbarHeight } from "../theme";
import Navbar from "./Navbar";
import { useLocation, useNavigate } from "react-router-dom";

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...(open && {
            ...openedMixin(theme),
            "& .MuiDrawer-paper": openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            "& .MuiDrawer-paper": closedMixin(theme),
        }),
    }),
);

const DesktopNavigation = ({ children, menuItems }) => {

    const [open, setOpen] = React.useState(false)

    const handleDrawerOpen = () => { setOpen(true) }
    const handleDrawerClose = () => { setOpen(false) }

    const navigate = useNavigate()

    const handleNavigate = route => () => { navigate(route) }

    const location = useLocation()

    const isCurrentPage = (path) => location.pathname.includes(path)

    const theme = useTheme()

    return <Box sx={{ display: "flex", height: "100%" }}>

        <Navbar
            open={open}
            onOpen={handleDrawerOpen}
            showDrawerMenu
        />

        <Drawer
            variant="permanent"
            open={open}
        >

            <DrawerHeader>
                <IconButton onClick={handleDrawerClose}>
                    <ChevronLeftIcon />
                </IconButton>
            </DrawerHeader>

            <Divider />

            <List>
                {menuItems.map((item, index) => {

                    const selected = isCurrentPage(item.path)

                    return <ListItem
                        key={index}
                        disablePadding
                        sx={{ display: "block" }}
                    >
                        <ListItemButton
                            onClick={handleNavigate(item.path)}
                            selected={isCurrentPage(item.path)}
                        >
                            <ListItemIcon>
                                <item.icon sx={{ color: selected ? theme.palette.primary.main : theme.palette.secondary.main  }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={item.name}
                                sx={{ color: selected ? theme.palette.primary.main : theme.palette.secondary.main }}
                            />
                        </ListItemButton>
                    </ListItem>
                })}
            </List>

        </Drawer>

        <Paper
            component="main"
            sx={{
                mt: `${navbarHeight}px`,
                height: `calc(100vh - ${navbarHeight}px)`,
                width: "100%",
                overflow: "auto"
            }}
        >
            {children}
        </Paper>

    </Box>
}

export default DesktopNavigation